<template>
        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}<span class="page_title_value">{{
                        this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">

                    <v-row>
                        <v-col cols="4" sm="10" class="pb-n5">
                            <v-autocomplete outlined :label="this.$t('columns.staffname')" type="text"
                                :rules="[rules.required]" v-model="formData.staffid" dense @input="updateValue"
                                :items="staffDetailsList"
                                @change="changeStaffIDandCompanyHandler(formData.staffid)"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="5" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('columns.staffcode')" type="text" ref="staffid"
                                :rules="[rules.required]" v-model="formData.staffcode" dense readonly
                                background-color="#ffeab2"></v-text-field>
                        </v-col>

                        <v-col cols="8" sm="5" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('columns.company')" type="text" ref="compnyid"
                                v-model="formData.compnyname" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete dense :label="this.$t('arrearsexercise.arrearsexercise')" ref="bpexerciseid"
                                outlined v-model="formData.bpexerciseid" :rules="[rules.required]"
                                :items="bpexercisesList" hide-selected
                                @change="changeBpexerciseHandler(formData.bpexerciseid)"></v-autocomplete>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.bpexercisecode')" type="text"
                                ref="bpexercisecode" v-model="formData.bpexercisecode" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete dense :label="this.$t('latenessdeduction.payitem')" ref="payitemid" outlined
                                v-model="formData.payitemid" :rules="[rules.required]" :items="payItemList"
                                hide-selected @change="changePayitemHandler(formData.payitemid)"></v-autocomplete>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('latenessdeduction.payitemcode')" type="text"
                                ref="payitemcode" v-model="formData.payitemcode" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete dense :label="this.$t('reportsparam.payout')" ref="bpexercisepoid" outlined
                                v-model="formData.bpexercisepoid" :rules="[rules.required]" :items="payoutcodesList"
                                hide-selected @change="changePayoutHandler(formData.bpexercisepoid)"></v-autocomplete>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('claimrecordlisting.payoutcode')" type="text"
                                ref="payoutcode" v-model="formData.payoutcode" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('statutoryexportcommonused.payoutyear')"
                                type="number" v-model="formData.pyyear" readonly background-color="#ffeab2"
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('statutoryexportcommonused.payoutmonth')"
                                type="number" v-model="formData.pymonth" readonly background-color="#ffeab2"
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('columns.currency')" type="text"
                                v-model="formData.crcycode" readonly background-color="#ffeab2" dense></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('recassetrec.quantity')" type="number" step="any"
                                ref="quantity" v-model="formData.quantity" readonly background-color="#ffeab2"
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.oldamt')" type="number" step="any"
                                ref="oldamt" v-model="formData.oldamt" readonly background-color="#ffeab2"
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.newamt')" type="number" step="any"
                                ref="newamt" :rules="[rules.required]" v-model="formData.newamt" dense append-icon=""
                                @input="updateValue" @change="populateDiff(formData.newamt)"></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.diffamt')" type="number" step="any"
                                ref="diffamt" v-model="formData.diffamt" readonly background-color="#ffeab2"
                                dense></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="5" sm="5" class="pb-n5 mt-n8">
                            <v-checkbox :label="this.$t('arrearsexercise.included')" v-model="formData.topay"
                                input-value="true" disabled>
                            </v-checkbox></v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3" sm="3" class="pb-n5 mt-n8">
                            <v-checkbox :label="this.$t('arrearsexercise.posted')" v-model="formData.posted"
                                input-value="true" disabled>
                            </v-checkbox></v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.payoutposted')" type="text"
                                ref="poid" v-model="formData.postedpayoutdesc" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" class="pb-n5 mt-n8">
                            <v-text-field outlined :label="this.$t('arrearsexercise.payoutpostedcode')" type="text"
                                ref="postedpayoutcode" v-model="formData.postedpayoutcode" dense readonly append-icon=""
                                background-color="#ffeab2"></v-text-field>
                        </v-col>
                    </v-row>


                </v-container>

                <app-formbuttons v-bind:EditBool=this.parentObject.isEdit v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" />

            </v-form>
        </v-container>

</template>

<script>

export default {
    props: {
        parentObject: Object
    },

    components: {
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || 'Value is 1-100'
            },

            formData: {
                staffid: this.parentObject.data.staffid,
                staffcode: this.parentObject.data.staffcode,
                compnyname: this.parentObject.data.compnydesc,
                bpexerciseid: this.parentObject.data.bpexerciseid,
                bpexercisecode: this.parentObject.data.bpexercisecode,
                bpexercisepoid: this.parentObject.data.bpexercisepoid,
                payoutcode: this.parentObject.data.oripocode,
                payitemid: this.parentObject.data.payitemid,
                payitemcode: this.parentObject.data.payitemcode,
                quantity: this.parentObject.data.quantity,
                oldamt: this.parentObject.data.oldamt,
                newamt: this.parentObject.data.newamt,
                diffamt: this.parentObject.data.diffamt,
                crcyid: this.parentObject.data.crcyid,
                topay: this.parentObject.data.topay,
                posted: this.parentObject.data.posted,
                postedpayoutcode: this.parentObject.data.payoutcode,
                postedpayoutdesc: this.parentObject.data.payoutdesc,
                search: this.parentObject.data.search,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid
            },
            itemData: {
                itemcode: null,
                itemdesc: null,
                itemstamp: 0
            },

            idno: '',

            staffDetailsList: [],
            payItemList: [],
            bpexercisesList: [],
            payoutcodesList: [],
            arrearspo:[],

            staffdetails: [],
            payItems: [],
            bpexercises: [],
            payoutcodes: [],

            errMsg: '',
            isErr: false,

            icdetails: [],
            search: this.parentObject.searchnew
        }
    },

    methods: {

        //change staffid and compnyid after selectin psnid
        changeStaffIDandCompanyHandler(id) {
            let item = this.staffdetails.find((item) => item.id === id);

            //set psnid to psnid and staffid to staffid
            this.formData.psnid = item.psnid;
            this.formData.staffid = item.id;
            this.formData.staffcode = item.staffcode;
            this.formData.compnyname = item.compnyname;
            this.formData.compnyid = item.compnyid;

            this.populateAmt();
        },

        //load staff details list
        loadStaffDetailsListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: `/staff/all/${this.$store.getters.userId}` })
                .then((res) => {
                    vm.staffdetails = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.staffDetailsList.push({
                            text: res.data.rec[i].psndetails,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadBpexerciseListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/arrearsexercise/all' })
                .then(res => {
                    vm.bpexercises = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.bpexercisesList.push(
                            {
                                text: res.data.rec[i].bpexercisedesc,
                                value: res.data.rec[i].id
                            }
                        )
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        getArrearsPOListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: `/arrearsexercisepo/all`
            })
                .then(function (res) {
                    vm.arrearspo = res.data.rec;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
        },

        loadPayitemListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/payitems/all' })
                .then(res => {
                    vm.payItems = res.data.rec;

                    for (let i = 0; i < vm.payItems.length; i++) {
                        if (["BASIC", "BONUS", "OT", "ALLW", "DEDT", "NPAY", "STAT"].includes(vm.payItems[i].payitemcatcode.toUpperCase())) {
                            vm.payItemList.push({
                                text: vm.payItems[i].payitemdesc,
                                value: vm.payItems[i].id,
                            });
                        }
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadPayoutCode() {
            const vm = this;
            this.$store.dispatch('get', {
                url: '/payoutctrl/all'
            })
                .then(res => {
                    vm.payoutcodes = res.data.rec;
                    if (vm.formData.bpexerciseid) {
                        vm.changeBpexerciseHandler(vm.formData.bpexerciseid);
                    }
                    if (vm.formData.bpexercisepoid) {
                        vm.changePayoutHandler(vm.formData.bpexercisepoid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        changeBpexerciseHandler(id) {
            let item = this.bpexercises.find(item => item.id === id);

            this.formData.bpexercisecode = item.bpexercisecode;
            this.payoutcodesList = this.arrearspo.filter(po => po.bpexerciseid === id).map(po => ({
                text: po.oripodesc,
                value: po.id
            }));
        },

        changePayitemHandler(id) {
            let item = this.payItems.find(item => item.id === id);
            this.formData.payitemcode = item.payitemcode;

            this.populateAmt();
        },

        changePayoutHandler(id) {
            let po = this.arrearspo.find(item => item.id === id);
            let item = this.payoutcodes.find(item => item.id === po.oripoid);
            this.formData.oripoid = po.oripoid;
            this.formData.payoutcode = item.payoutcode;
            this.formData.crcyid = item.crcyid;
            this.formData.crcycode = item.crcycode;
            this.formData.pyyear = item.pyyear;
            this.formData.pymonth = item.pymonth;

            this.populateAmt();
        },

        populateAmt() {
            const vm = this;
            if (!this.formData.staffid || !this.formData.payitemid || !this.formData.oripoid) {
                vm.formData.oldamt = '';
                vm.formData.diffamt = '';
                vm.formData.quantity = '';
                return;
            }
                this.$store.dispatch('get', { url: `/salpayitem/${this.formData.staffid}/${this.formData.payitemid}/${this.formData.oripoid}` })
                .then(res => {
                    if (res.data.rec.length > 0) {
                        vm.formData.oldamt = res.data.rec[0].aprvamt;
                        vm.formData.quantity = res.data.rec[0].aprvqty;
                    } else {
                        vm.formData.oldamt = '';
                        vm.formData.quantity = '';
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', { isErr: vm.isErr, errMsg: vm.errMsg });
                });
            this.populateDiff(vm.formData.newamt);
            return;
        },

        populateDiff(newAmt) {
            this.formData.diffamt = Math.round((newAmt - this.formData.oldamt) * 100) / 100;
            this.updateValue();
        },

        updateValue() {

            this.$emit('input', {
                staffid: this.formData.staffid,
                bpexerciseid: this.formData.bpexerciseid,
                bpexercisepoid: this.formData.bpexercisepoid,
                payitemid: this.formData.payitemid,
                quantity: this.formData.quantity,
                oldamt: this.formData.oldamt,
                newamt: this.formData.newamt,
                diffamt: this.formData.diffamt,
                crcyid: this.formData.crcyid,
                topay: this.formData.topay,
                search: this.formData.search,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });


        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            if (this.$refs.form.validate()) {
                this.$emit("save");
            }
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({ name: 'arrearstransactionlist', params: { search: this.search } });
        },

    },

    mounted() {
        this.loadStaffDetailsListHandler();
        this.loadBpexerciseListHandler();
        this.loadPayitemListHandler();
        this.getArrearsPOListHandler();
        this.loadPayoutCode();

    }
}
</script>

<style>
.removeSpin input[type='number'] {
    -moz-appearance: textfield;
    -moz-appearance: autocomplete;
}

.removeSpin input::-webkit-outer-spin-button,
.removeSpin input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>